import React from 'react';
import { UserPlus } from 'lucide-react';

const inputCls = 'w-full px-3 py-2.5 bg-white border border-neutral-200 rounded-sm font-sans-ah text-[14px] focus:outline-none focus:border-[#4a9cd4] transition-colors';

export const resizeGuests = (guests, count) => {
  const n = Math.max(0, count);
  return guests.length === n ? guests : [...guests.slice(0, n), ...Array.from({ length: Math.max(0, n - guests.length) }, () => ({ name: '', email: '', phone: '' }))];
};

export function GuestFields({ guests, onChange }) {
  if (!guests.length) return null;
  const set = (i, k, v) => onChange(guests.map((g, j) => (j === i ? { ...g, [k]: v } : g)));
  return (
    <div data-testid="rsvp-guest-fields">
      <p className="font-sans-ah text-[12px] tracking-wide-ah text-[#666] uppercase flex items-center gap-2"><UserPlus size={15} className="text-[#4a9cd4]" /> Your guests</p>
      <p className="font-sans-ah text-[12px] text-[#999] mb-3">Name is required. Add an email and we'll send them their own confirmation and reminder.</p>
      <div className="space-y-3">
        {guests.map((g, i) => (
          <div key={i} className="bg-[#f8f6f2] rounded-sm p-3.5" data-testid={`rsvp-guest-${i}`}>
            <p className="font-sans-ah text-[11px] tracking-wide-ah text-[#4a9cd4] mb-2">GUEST {i + 1}</p>
            <div className="grid sm:grid-cols-3 gap-2">
              <input value={g.name} onChange={(e) => set(i, 'name', e.target.value)} placeholder="Full name *" aria-label={`Guest ${i + 1} full name`} data-testid={`rsvp-guest-name-${i}`} className={inputCls} />
              <input type="email" value={g.email} onChange={(e) => set(i, 'email', e.target.value)} placeholder="Email (optional)" aria-label={`Guest ${i + 1} email`} data-testid={`rsvp-guest-email-${i}`} className={inputCls} />
              <input type="tel" value={g.phone} onChange={(e) => set(i, 'phone', e.target.value)} placeholder="Phone (optional)" aria-label={`Guest ${i + 1} phone`} data-testid={`rsvp-guest-phone-${i}`} className={inputCls} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
